<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="prestataire_id" placeholder="Choisissez prestataire " name="prestataire_id" id="prestataire_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{ item.libelle}}
    </ng-option>
</ng-select>